@if (show()) {
  <div class="spinner-container">
    <div class="spinner-border" role="status">
      <span class="spinner"></span>
    </div>
  </div>
}
